import React from 'react';
import { createRoot } from 'react-dom/client';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter
import App from './App';
import './index.css'; // Import any global styles
import swal from 'sweetalert';

// Le swal si chiudono solo dai bottoni: niente click esterno né ESC
swal.setDefaults({ closeOnClickOutside: false, closeOnEsc: false });

// ...e niente Invio (né sul bottone col focus né negli input)
const bloccaInvioSwal = (e) => {
  if (e.key === 'Enter' && swal.getState().isOpen) {
    e.preventDefault();
    e.stopPropagation();
  }
};
window.addEventListener('keydown', bloccaInvioSwal, true);
window.addEventListener('keyup', bloccaInvioSwal, true);

const container = document.getElementById('root');
const root = createRoot(container); 
root.render(<BrowserRouter> 
  <App />
</BrowserRouter>);

